// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__lmnG9","label":"Completed_label__3d1Ac"};